/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*****************************************!*\
  !*** ./scripts/shoes-recommendation.js ***!
  \*****************************************/
var mainProductRecommendURL = document.querySelector('.product-reference').getAttribute('data-product-url');
var recommendSize = document.querySelector('.recommended-size .show-data');
var recommendValue = recommendSize.querySelector('.value');
var padelRecommend = document.querySelector('shoes-recommend');
var main = padelRecommend.querySelector('.url-select');
var mainSelectBtn = main.querySelector('.select-btn-url');
var mainSBtnText = main.querySelector('.sBtn-text-url');
var sub = padelRecommend.querySelector('.size-select');
var subSelectBtn = sub.querySelector('.select-btn-size');
var subSBtnText = sub.querySelector('.sBtn-text-size');
var reference_size = padelRecommend.querySelector('.reference-size');
var selectedBrand = reference_size.querySelector('.brand');
var selectedSize = reference_size.querySelector('.size');

// Width fix for options
var optionWidthFix = function optionWidthFix() {
  var optionWidth = document.querySelector('.select-menu');
  document.querySelectorAll('.select-menu .options').forEach(function (option) {
    option.style.maxWidth = "".concat(optionWidth.getBoundingClientRect().width + 1, "px");
  });
};
optionWidthFix();
mainSelectBtn.onclick = function () {
  main.classList.toggle('active');
  main.querySelectorAll('.option').forEach(function (option) {
    option.onclick = function () {
      recommendSize.classList.add('hidden');
      recommendSize.classList.remove('error');
      recommendSize.classList.remove('success');
      toRenderOptionReference(option.getAttribute('data-url'));
      option.classList.add('is-active');
      mainSBtnText.innerText = option.querySelector('.option-text').innerText;
      selectedBrand.innerText = option.querySelector('.option-text').innerText;
      subSelectBtn.classList.remove('disabled');
      main.classList.remove('active');
    };
  });
};
var toRenderOptionReference = function toRenderOptionReference(url) {
  reference_size.classList.add('hidden');
  subSBtnText.innerHTML = 'Select Size';
  fetch(url).then(function (response) {
    return response.text();
  }).then(function (responseText) {
    var html = new DOMParser().parseFromString(responseText, 'text/html');
    var sourceOption = html.querySelector('.full-data');
    sub.querySelector('.options').innerHTML = sourceOption.innerHTML;
    subFnOptions();
  })["catch"](function (e) {
    console.error(e);
  });
};
var subFnOptions = function subFnOptions() {
  subSelectBtn.onclick = function (e) {
    if (subSelectBtn.classList.contains('disabled')) {
      return;
    }
    sub.classList.toggle('active');
    sub.querySelectorAll('.option').forEach(function (option) {
      option.onclick = function () {
        option.classList.add('is-active');
        subSBtnText.innerText = option.querySelector('.option-text').innerText;
        selectedSize.innerText = option.querySelector('.option-text').innerText;
        reference_size.classList.remove('hidden');
        sub.classList.remove('active');
        RecommendCheck(mainProductRecommendURL, option.getAttribute('data-size'));
      };
    });
  };
};
var RecommendCheck = function RecommendCheck(url, dataSize) {
  recommendSize.classList.remove('error');
  recommendSize.classList.remove('success');
  fetch(url).then(function (response) {
    return response.text();
  }).then(function (responseText) {
    var html = new DOMParser().parseFromString(responseText, 'text/html');
    var sourceOption = html.querySelector(".full-data li[data-size=\"".concat(dataSize, "\"]"));
    var mainBrand = html.querySelector(".brand-name").getAttribute('data-brand');
    var mainValue = sourceOption.getAttribute('data-value');

    //Recomended here
    if (mainValue == '-') {
      recommendValue.innerHTML = "Vi fandt desv\xE6rre ikke nogen str. i  ".concat(mainBrand, ", som svarer til dine valg.");
      recommendSize.classList.remove('hidden');
      recommendSize.classList.add('error');
      return;
    }
    recommendValue.innerHTML = "Vores eksperter anbefaler st\xF8rrelse ".concat(mainValue, " hos ").concat(mainBrand, ".");
    recommendSize.classList.remove('hidden');
    recommendSize.classList.add('success');
  })["catch"](function (e) {
    console.error(e);
  });
};
window.addEventListener('resize', function (event) {
  optionWidthFix();
}, true);
/******/ })()
;